import type { FaireProductEntity } from "../../entity_types/product";

export const p_njjbfes7vs: FaireProductEntity = {
  token: "p_njjbfes7vs",
  type: "product",
  name: "GREETINGS FROM MAUI POSTCARD - BLUE/PINK - HAWAII BACK",
  brandName: "Lauren Taylor Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/acf99bd039ce07c712593992271f5b1439292088ac854b342157f796534909a8.jpeg",
  priceDollars: 1.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6148f33a73a91c196d9c28fa97987f81b4d40356b0b37e9d12c54f7f092845a5.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
